import type { FaqItem } from '../types/portfolio';

export const faqItems: FaqItem[] = [
  {
    question: 'In welchen Dateiformaten liefern Sie die Daten?',
    answer:
      'Sie erhalten alle gängigen Industrieformate: STEP, IGES, DXF, DWG, Parasolid (X_T / X_B), STL für den 3D-Druck sowie fertigungsgerechte PDFs und native CAD-Dateien.',
  },
  {
    question: 'Welche Software nutzen Sie für die Konstruktion?',
    answer:
      'Mein Fokus liegt primär auf Autodesk Inventor und AutoCAD. Durch den Export in neutrale High-End-Formate wie STEP oder Parasolid sind die Daten zu 100 % kompatibel mit SolidWorks, CATIA, Solid Edge und Siemens NX.',
  },
  {
    question: 'Für welche Branchen und Fachbereiche konstruieren Sie?',
    answer:
      'Ich bin spezialisiert auf Maschinenbau, Anlagenbau, Sondermaschinen, Blechkonstruktionen sowie Schweißbaugruppen und technische Konsumprodukte.',
  },
  {
    question: 'Sind Sie für den Schadensfall abgesichert?',
    answer:
      'Ja. Als professioneller B2B-Partner bin ich über eine Betriebshaftpflichtversicherung mit einer Deckungssumme von 5 Millionen Euro für Personen-, Sach- und Vermögensschäden abgesichert.',
  },
  {
    question: 'Was unterscheidet Ihre CAD-Modelle von anderen?',
    answer:
      'Ich konstruiere streng parametrisch und lege extremen Wert auf eine saubere, logische Modellhistorie. Der Modellbaum bleibt änderungsstabil und bricht bei späteren Anpassungen durch Ihr Team nicht zusammen.',
  },
  {
    question: 'Bieten Sie auch die Digitalisierung bestehender Bauteile an?',
    answer:
      'Ja. Im Zuge des Reverse Engineering rekonstruiere ich physische Muster, alte Papierzeichnungen oder sogar Fotovorlagen in vollständig bearbeitbare, moderne 3D-CAD-Modelle.',
  },
  {
    question: 'Wie sicher sind meine Daten und Konstruktionsideen?',
    answer:
      'Maximale Diskretion steht an erster Stelle. Vor Projektbeginn unterzeichnen wir eine Geheimhaltungsvereinbarung (NDA). Der Datenaustausch erfolgt über meinen geschützten B2B-Downloadbereich.',
  },
  {
    question: 'Wie werden die Projekte abgerechnet?',
    answer:
      'Sowohl Festpreise als auch eine Abrechnung nach Aufwand sind möglich. Für klar definierte Aufgaben wie Einzelteilkonstruktionen oder Zeichnungsableitungen starten kleine Projektpakete bereits ab 400 €.',
  },
];
